/* Every two-column product gallery fits below the header and stays sticky. */
(() => {
  'use strict';
  const states = new Map();
  const bind = scope => scope.querySelectorAll('[data-tf-gallery]').forEach(gallery => {
    if (states.has(gallery)) return;
    const header = document.querySelector('.tf-header');
    let frame = 0;
    const update = () => {
      frame = 0;
      const desktop = window.innerWidth >= 961;
      const offset = Math.ceil(header?.getBoundingClientRect().height || 100) + 24;
      gallery.style.setProperty('--tf-gallery-sticky-top', `${offset}px`);
      gallery.classList.toggle('tf-gallery--sticky', desktop);
      if (!desktop) {
        gallery.style.removeProperty('--tf-gallery-media-max-height');
        return;
      }
      const thumbs = gallery.querySelector('.tf-gallery__thumbs');
      const styles = thumbs ? getComputedStyle(thumbs) : null;
      const thumbHeight = thumbs ? thumbs.getBoundingClientRect().height +
        (parseFloat(styles.marginBlockStart) || 0) + (parseFloat(styles.marginBlockEnd) || 0) : 0;
      const gap = thumbs ? parseFloat(getComputedStyle(gallery).rowGap) || 0 : 0;
      const mediaHeight = Math.max(0, Math.floor(window.innerHeight - offset - 24 - thumbHeight - gap));
      gallery.style.setProperty('--tf-gallery-media-max-height', `${mediaHeight}px`);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('resize', schedule, { passive:true });
    gallery.addEventListener('load', schedule, true);
    const observer = window.ResizeObserver ? new ResizeObserver(schedule) : null;
    observer?.observe(gallery);
    if (header) observer?.observe(header);
    document.fonts?.ready?.then(() => { if (gallery.isConnected) schedule(); });
    states.set(gallery, () => {
      if (frame) cancelAnimationFrame(frame);
      window.removeEventListener('resize', schedule);
      gallery.removeEventListener('load', schedule, true);
      observer?.disconnect();
      states.delete(gallery);
    });
    schedule();
  });
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-tf-gallery]').forEach(gallery => states.get(gallery)?.());
  });
})();
